import { createSelector } from "reselect";

export const getLastVisit = (state) => state.last_visit;
const getTaskLastVisit = createSelector(
  getLastVisit,
  (state, id) => `Task-${id}`,
  (lastVisit, key) => {
    return lastVisit[key];
  }
);
const getParentLastVisit = (state, parentType, parentId) => {
  const key = `${parentType}-${parentId}`;
  const parentLastVisit = getLastVisit(state) || {};

  return parentLastVisit[`${key}`];
};

export const getTaskLastVisitTimestampSelector = createSelector(
  getTaskLastVisit,
  (taskLastVisit) => taskLastVisit?.last_visit_timestamp
);

export const getParentLastVisitTimestampSelector = createSelector(
  getParentLastVisit,
  (parentLastVisit) => parentLastVisit?.last_visit_timestamp
);

export const getCommentListTopInViewportByParent = createSelector(getParentLastVisit, (parent) => {
  return parent?.comment_list_top_in_viewport;
});
